import ZPreloader from './ZPreloader.vue'

export default ZPreloader
